import { render, staticRenderFns } from "./TitleImageAndHeadline.vue?vue&type=template&id=9328939c&scoped=true&"
import script from "./TitleImageAndHeadline.vue?vue&type=script&lang=ts&"
export * from "./TitleImageAndHeadline.vue?vue&type=script&lang=ts&"
import style0 from "./TitleImageAndHeadline.vue?vue&type=style&index=0&id=9328939c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9328939c",
  null
  
)

export default component.exports